import "./index.scss";

import ModalNonBlocked from "../modal/modal-non-blocked";


const initMyProglib = () => {
    let opener = document.getElementById('show-my-proglib');
    let myProglib = document.getElementById('my-proglib');
    if (!opener || !myProglib) return;
    let myProglibModal = ModalNonBlocked.get(myProglib);
    let tagsBlock = document.getElementById('tags-filter');

    /** Открыть модальное окно */
    opener.addEventListener('click', function() {
      myProglibModal.open();
      if (tagsBlock) tagsBlock.classList.add('hidden');
    });

    myProglib.addEventListener('popup.events.closed', function() {
      if (tagsBlock) tagsBlock.classList.remove('hidden');
    });
};

export { initMyProglib };

